import {Modal, Button, Form, Row, Col} from 'react-bootstrap';
import {useState, useMemo} from 'react';
import {useDispatch} from 'react-redux';
import API from '../helpers/api';
import moment from 'moment';


export default function ChangeEmailAddressModal({close, accountId}) {
    const dispatch = useDispatch();
    const api = useMemo(() => new API({dispatch}), []);
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const success = await api.changeUserEmail(accountId, email);
            if (success) {
                close();
            }
        } catch(err){
            console.error('Error changing email:', err);
            alert('There was an error changing the email address. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <Modal show onHide={close}>
            <Modal.Header closeButton>
                <Modal.Title>Change Email Address</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                        <Form.Label column sm="3">
                            New Email Address
                        </Form.Label>
                        <Col sm="9">
                            <Form.Control
                                type="email"
                                placeholder="Enter new email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                disabled={isSubmitting}
                            />
                        </Col>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={close} disabled={isSubmitting}>
                        Cancel
                    </Button>
                    <Button variant="primary" type="submit" disabled={isSubmitting || !email}>
                        {isSubmitting ? 'Submitting...' : 'Submit'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}